/*
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    userinfo: localStorage.getItem('userinfo')?JSON.parse(localStorage.getItem('userinfo')):null, //对象 
  },
  getters: {
  },
  mutations: {
    //登录成功==  
    loginSuc(state,userinfo){
      state.userinfo = userinfo //对象
      localStorage.setItem('userinfo',JSON.stringify(userinfo)) //字符串    
        
    },
  },
  actions: {
    // 登录成功===
      loginSuccess(context,userinfo){
         context.commit('loginSuc',userinfo)
      },
  },
  modules: {
  }
})
